import API from "@/api";
import useRouter from "@/hooks/useRouter";
import { getUserInfoMethod } from "@/redux/reducers/authSlice";
import { AppDispatch, RootState } from "@/redux/store";
import { pxToRem } from "@/util/common";
import { isDef } from "@/util/validate";
import { CenterPopup } from "antd-mobile";
import { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { useDispatch, useSelector } from "react-redux";

const GiftPopup: React.FC<{
	visible: boolean;
	onClose: () => void;
}> = ({ visible, onClose }) => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { customNavigate } = useRouter();
	const userInfo = useSelector((state: RootState) => state.auth.userInfo);
	const [disabled, setDisabled] = useState(false);
	const [timeNum, setTimeNum] = useState(0);
	const [isCounting, setIsCounting] = useState(false);
	const [stateComplete, setStateComplete] = useState<number[]>([]); // 1:时间、2:接口

	useEffect(() => {
		let timer: NodeJS.Timeout | undefined;
		const startCountdown = () => {
			timer = setInterval(() => {
				setTimeNum((prevTimeNum) => {
					if (prevTimeNum === 0) {
						clearInterval(timer);
						setIsCounting(false);
						setStateComplete((prevData) => [
							...new Set([...prevData, 2]),
						]);
						return 0;
					}
					return prevTimeNum - 1;
				});
			}, 1000);
		};

		if (isCounting) {
			startCountdown();
		} else {
			timer && clearInterval(timer);
		}

		return () => {
			timer && clearInterval(timer);
		};
	}, [isCounting]);

	const startHandle = () => {
		setIsCounting(true);
		setTimeNum(2);
		postFinanceWaterReceive();
	};

	const goToPageHandle = () => {
		if (!isDef(userInfo)) return;
		const outerParams = {
			nickname: userInfo.nickname,
			walletAddress: userInfo.walletAddress,
			inviteRemake: "",
		};
		// customNavigate(
		// 	"/personnal-receive-records" +
		// 		"/" +
		// 		userInfo.id +
		// 		"/" +
		// 		JSON.stringify(outerParams)
		// );
		customNavigate("/cashbackRecord");
	};

	const postFinanceWaterReceive = async () => {
		try {
			setDisabled(true);
			const result: any = await API.finances.apiFinanceWaterReceive({});
			if (result?.code === 0) {
				setStateComplete((prevData) => [...new Set([...prevData, 1])]);
				dispatch(getUserInfoMethod());
			}
		} catch (error) {
			console.log("---apiFinanceWaterReceive--:", error);
		} finally {
			setStateComplete((prevData) => [...new Set([...prevData, 1])]);
		}
	};

	useEffect(() => {
		if (stateComplete.length >= 2) {
			goToPageHandle();
			setDisabled(false);
		}
	}, [stateComplete]);

	return (
		<CenterPopup
			bodyStyle={{
				width: "100vw",
			}}
			visible={visible}
			closeOnMaskClick
			destroyOnClose
			onClose={onClose}
			bodyClassName={classes.popupContent}
			maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
			style={{
				"--max-width": "100vw",
			}}
		>
			<div className={classes.giftRewardsWrap}>
				{/* <h2>Rewards</h2> */}
				<div
					onClick={startHandle}
					className={`giftBox ${isCounting && "animation"}`}
				></div>
				{/* <Image
					className="giftBox giftShadow"
					src={require("@/assets/images/game/gift_box.png")}
					fit="cover"
				/> */}
			</div>
			{/* <Button
				onClick={startHandle}
				disabled={disabled}
				className={`${classes.btn}`}
				shape="rounded"
			>
				OPEN MY REWARD
			</Button> */}
		</CenterPopup>
	);
};

export default GiftPopup;

const useStyles = createUseStyles({
	popupContent: {
		color: "#fff",
		textAlign: "center",
		padding: {
			bottom: pxToRem(20),
		},
		backgroundColor: "transparent",
	},
	giftRewardsWrap: {
		position: "relative",
		height: pxToRem(220),
		// border: "1px solid #000000",
		borderBottomLeftRadius: pxToRem(20),
		borderBottomRightRadius: pxToRem(20),
		// backgroundColor: "#1E1E1E",
		marginBottom: pxToRem(18),
		// boxShadow: `0 ${pxToRem(4)} ${pxToRem(4)} rgba(0, 0, 0, 0.25)`,
		backgroundRepeat: "no-repeat",
		backgroundSize: "100% 100%",
		// backgroundImage: `url(${require("@/assets/images/game/gift_bg.png")})`,
		"& h2": {
			fontSize: pxToRem(16),
			fontWeight: "600",
			textAlign: "center",
			marginTop: pxToRem(16),
		},
		"& .giftBox": {
			position: "absolute",
			left: "50%",
			top: 0,
			bottom: pxToRem(80),
			width: pxToRem(224),
			height: pxToRem(219),
			marginLeft: pxToRem(-112),
			backgroundRepeat: "no-repeat",
			backgroundSize: "100% 100%",
			backgroundImage: `url(${require("@/assets/images/game/gift_box.png")})`,
			"&.animation": {
				animation:
					"shake 0.5s ease infinite, shadowFilter 2s linear forwards",
			},
		},
	},
	btn: {
		width: pxToRem(292),
		height: pxToRem(50),
		margin: "0 auto",
		boxShadow: `inset 0 ${pxToRem(2)} ${pxToRem(
			4
		)} rgba(0,194,255, 0.25), 0 ${pxToRem(10)} ${pxToRem(
			10
		)} rgba(24,77,237, 0.3)`,
		"--border-width": 0,
		"--text-color": "#FFFFFF",
		background: "linear-gradient(to right,#4675FF, #0E329D)",
	},
});
